import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon } from 'lucide-react';
import { PromoCountdown } from './PromoCountdown';
import { pricing, warrantyCopy, SALE_NAME, SALE_TAGLINE } from '../data/promotion';
import { money } from './QuantityStepper';

/**
 * The first pricing information a visitor sees: discount, regular vs launch
 * price, total separate value, the warranty and the weekly countdown.
 * The three prices ($166.60 value, $124.95 regular, $49.95 launch) are kept
 * visually distinct so they are never confused with each other.
 */
export function LaunchOfferPanel() {
  return <div className="mt-8 grid gap-px border border-white/12 bg-white/10 lg:grid-cols-[1.25fr_1fr]" data-id="element-345" data-mp="12fo6cou3ab0c">
      <div className="bg-ink-950 p-5 sm:p-7" data-id="element-346" data-mp="17cxv029nmin4">
        <div className="flex flex-wrap items-center gap-3" data-id="element-347" data-mp="17bwma4g4288k">
          <span className="bg-grit-500 px-3 py-1.5 font-display text-2xl font-extrabold uppercase leading-none text-ink-950 sm:text-3xl" data-id="element-348" data-mp="1v2s6ogi8m15s">
            {pricing.discountPct}% off
          </span>
          <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-349" data-mp="2d8smvd0jahz5">★ {SALE_NAME}</span>
        </div>
        <p className="mt-3 max-w-xl text-[14px] font-medium text-steel-300" data-id="element-350" data-mp="28ahel6pw0fj1">{SALE_TAGLINE}</p>

        <p className="mt-5 flex flex-wrap items-end gap-x-4 gap-y-1" data-id="element-351" data-mp="2m1m8rtahkflz">
          <span className="pb-1 text-lg text-steel-400" data-id="element-352" data-mp="2h89uabzitp6y">
            <span className="sr-only" data-id="element-353" data-mp="2h7i095lknzis">Regular price </span>
            <span className="line-through" data-id="element-354" data-mp="2vwxpgh5gfwwd">{money(pricing.regular)}</span>
          </span>
          <span className="font-display text-6xl font-extrabold leading-none text-offwhite sm:text-7xl" data-id="element-355" data-mp="2qyckk4f9cp1l">
            {money(pricing.launch)}
          </span>
        </p>
        <p className="mt-2 font-display text-xl font-bold uppercase tracking-wide text-grit-500" data-id="element-356" data-mp="30wscuaq0u4co">
          You save {money(pricing.save)} from the regular price
        </p>

        <dl className="mt-5 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2" data-id="element-357" data-mp="1ampcpzfvwq54">
          <div className="bg-ink-900 px-4 py-3" data-id="element-358" data-mp="16lndhilywe35">
            <dt className="text-[10px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-359" data-mp="35p3zbti96l7r">Total separate value</dt>
            <dd className="mt-1 font-display text-3xl font-extrabold leading-none text-offwhite" data-id="element-360" data-mp="3anx50zrat7xd">
              {money(pricing.separateValue)}
            </dd>
          </div>
          <Link to="/legal/guarantee" className="flex items-center gap-3 bg-ink-900 px-4 py-3 transition-colors duration-150 ease-grit hover:bg-ink-850 focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500" data-id="element-361" data-mp="3kll8ce2yznr5">
            <ShieldCheckIcon className="h-7 w-7 shrink-0 text-grit-500" aria-hidden="true" data-id="element-362" data-mp="3tjn6mlvbk2aq" />
            <span data-id="element-363" data-mp="29excz59ruea">
              <span className="block text-[10px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-364" data-mp="76f3fa24cx5e">
                {warrantyCopy.value}
              </span>
              <span className="mt-0.5 block font-display text-lg font-bold uppercase leading-tight text-offwhite" data-id="element-365" data-mp="c7cn5r2s1z90">
                Lifetime warranty free on every multi-pack
              </span>
            </span>
          </Link>
        </dl>
      </div>

      <div className="flex flex-col justify-center bg-ink-950 p-5 sm:p-7" data-id="element-366" data-mp="1wn0xzhtk55rf">
        <PromoCountdown data-id="element-367" data-mp="1rofyjkm4qq41" />
        <p className="mt-4 text-[13px] leading-relaxed text-steel-400" data-id="element-368" data-mp="1rnxva411vbmm">
          Every system ships complete: glasses, 3 lenses, hard case, pouch, cloth, USB cable, anti-fog spray, guide
          and authenticity card.
        </p>
      </div>
    </div>;
}